<template>
  <div class="payment-card-loading">
    <AmLoading :class="`loading--${theme.color}`" />
    <AmTypography
      :class="`payment-card-loading__text text--${theme.color}`"
      :text="this.$t('steps.payment.paymentLoading')"
      typography-style="l3"
    />
  </div>
</template>

<script>
import themeMixin from '@/components/mixins/themeMixin'
import { mapMutations } from 'vuex'

export default {
  name: 'PaymentCardLoading',
  mixins: [themeMixin],
  mounted() {
    this.SET_CURRENT_STEP(10)
  },
  methods: {
    ...mapMutations('Checkout', ['SET_CURRENT_STEP', 'SET_DISABLED_STATE_PAYMENT']),
  },
}
</script>

<style lang="scss" scoped>
.payment-card-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;

  &__text {
    width: 300px;
    margin-top: 24px;
    text-align: center;
  }
}
</style>
